import AdminLogoutSvg from '@assets/svg/AdminLogout';
import { Button, cn } from 'shared-components';
import { type FunctionComponent, useState } from 'react';

import { Navigation } from '../Navigation';
import { type HeaderLayoutProps } from './HeaderLayout.types';

const HeaderLayout: FunctionComponent<HeaderLayoutProps> = ({
  navItems,
  currentRoles,
  isAuthenticated,
  onLogout,
  logoutLabel,
  menuLabel,
  logoSlot,
  accountSlot,
  centered,
  dataTestid,
  className,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header
      className={cn(
        'sticky top-0 right-0 left-0 z-9999 flex h-20 max-h-20 min-h-20 w-full items-center border-b border-secondary-200 bg-white px-4 py-3 shadow-2xs',
        className,
      )}
      data-testid={dataTestid}
    >
      <div
        className={cn(
          'mx-auto flex w-full max-w-350 items-center gap-4',
          centered ? 'justify-center' : 'justify-between',
        )}
      >
        {logoSlot}
        <div className="flex h-8 items-end gap-4">
          {accountSlot}
          {isAuthenticated && (
            <>
              <span className="h-8 max-w-px min-w-px flex-1 bg-secondary-400" />
              <Button
                name="admin-logout"
                variant="ghost"
                size="icon"
                className="hidden max-h-7.5 max-w-7 text-secondary-900 lg:flex"
                title={logoutLabel}
                aria-label={logoutLabel}
                onClick={onLogout}
              >
                <AdminLogoutSvg className="size-7 shrink-0" />
              </Button>
            </>
          )}
          <Navigation
            items={navItems}
            currentRoles={currentRoles}
            isAuthenticated={isAuthenticated}
            isMenuOpen={isMenuOpen}
            onToggleMenu={() => setIsMenuOpen((open) => !open)}
            onLogout={onLogout}
            logoutLabel={logoutLabel}
            menuLabel={menuLabel}
          />
        </div>
      </div>
    </header>
  );
};

HeaderLayout.displayName = 'HeaderLayout';
export { HeaderLayout };
